import React, { useMemo } from 'react';
import OrganizationAnalyticsBarChart from './OrganizationAnalyticsBarChart';
import { getAiSuggestionsUsageWithTotalMessagesTooltipFormatter, mapIdsToLabels } from './chartUtils';

const OrganizationChatterManualVsAiByChatterChart = ({ data, chatterLabelMap, pending }) => {
  const { categories, series, tooltipFormatter } = useMemo(() => {
    const rows = (data?.chatterIds || []).map((chatterId, index) => {
      const aiCount = Number(data?.aiMessageCount?.[index] || 0);
      const manualCount = Number(data?.manualMessageCount?.[index] || 0);
      const totalCount = aiCount + manualCount;

      return {
        category: mapIdsToLabels([chatterId], chatterLabelMap)[0],
        aiUsagePercentage: totalCount ? (aiCount / totalCount) * 100 : 0,
        totalMessages: Number(data?.totalCount?.[index] || 0),
      };
    });

    return {
      categories: rows.map(row => row.category),
      series: [
        {
          name: 'AI Suggestions Usage',
          data: rows.map(row => row.aiUsagePercentage),
          totalMessages: rows.map(row => row.totalMessages),
        },
      ],
      tooltipFormatter: getAiSuggestionsUsageWithTotalMessagesTooltipFormatter(),
    };
  }, [data, chatterLabelMap]);

  return (
    <OrganizationAnalyticsBarChart
      title="AI Suggestions Usage By Chatter"
      subtitle="AI suggestion usage percentage for each selected chatter."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select creators and chatters to load AI suggestions usage."
      valueType="percent"
      tooltipFormatter={tooltipFormatter}
    />
  );
};

export default OrganizationChatterManualVsAiByChatterChart;
